var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubbleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 34,
    viewBox: "0 0 102 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0415 7L83 0L78.9585 7H13.5C6.04416 7 0 13.0442 0 20.5C0 27.9558 6.04416 34 13.5 34H88.5C95.9558 34 102 27.9558 102 20.5C102 13.0442 95.9558 7 88.5 7H87.0415Z",
    fill: "#676ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleBlack);
export default __webpack_public_path__ + "static/media/SpeechBubbleBlack.68874ff9ffc19f94c5d1c19a9f0e8c43.svg";
export { ForwardRef as ReactComponent };